import { render, staticRenderFns } from "./PublicationCapacityCell.vue?vue&type=template&id=b891b0c0&"
import script from "./PublicationCapacityCell.vue?vue&type=script&lang=js&"
export * from "./PublicationCapacityCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports